import { SnSize } from '@lib/common/types';

interface ISnIconCommonConfig {
  size?: SnSize;
}

interface ISnIconConfig extends ISnIconCommonConfig {
  icon?: string;
  template?: string;
}

interface ISnSvgIconConfig extends ISnIconCommonConfig {
  svgIcon: string;
}

interface ISnFontIconConfig extends ISnIconCommonConfig {
  fontIcon: string;
  fontSet?: string;
  class?: string | (() => string);
}

interface ISnFontIconUnicodeConfig extends ISnIconCommonConfig {
  fontIconUnicode: string;
  fontSet?: string;
}

export type SnIconConfig =
  | string
  | ISnIconConfig
  | ISnSvgIconConfig
  | ISnFontIconConfig
  | ISnFontIconUnicodeConfig;
